<script>
const BETA = 'beta'
const EDITOR = 'editor'

export default {}
</script>

<script setup>
import { computed } from 'vue'
import { useVisibilityStore } from './../visibility/visibility.store'
import { storeToRefs } from 'pinia'

const visibilityStore = useVisibilityStore()
const { betaMode, editorMode } = storeToRefs(visibilityStore)
const { toggleBetaMode, toggleEditorMode } = visibilityStore

const props = defineProps({
  flagType: {
    required: true,
    type: String,
    validator(value) {
      return [BETA, EDITOR].indexOf(value) > -1
    }
  }
})

const label = computed(() => {
  if (props.flagType === BETA) {
    return 'BETA MODE'
  }
  if (props.flagType === EDITOR) {
    return 'EDITOR MODE'
  }
  return '(Undefined) Mode'
})

const flag = computed(() => {
  if (props.flagType === BETA) {
    return betaMode.value
  }
  if (props.flagType === EDITOR) {
    return editorMode.value
  }
  return false
})

function toggleMode() {
  if (props.flagType === BETA) {
    toggleBetaMode(!betaMode.value)
  }
  if (props.flagType === EDITOR) {
    toggleEditorMode(!editorMode.value)
  }
}
</script>
<template>
  <a class="-ml-2 flex items-center" role="button" @click.prevent.stop="toggleMode" tabindex="0">
    <span v-if="flag" class="material-icons-round mr-0.5 text-success">check_circle_outline</span>
    <span v-else class="material-icons-round mr-0.5 text-weak">radio_button_unchecked</span>
    <p class="text-sm font-bold shrink" :class="{ 'text-weak': !flag, 'text-success': flag }">
      {{ label }}
    </p>
  </a>
</template>
<style type="text/css"></style>
